// Copyright 2021 The Prometheus Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {
  And,
  Atan2,
  Avg,
  Bool,
  Bottomk,
  By,
  CardinalityEstimate,
  Count,
  CountValues,
  End,
  Fill,
  FillLeft,
  FillRight,
  Group,
  GroupLeft,
  GroupRight,
  Ignoring,
  inf,
  Max,
  Min,
  nan,
  Offset,
  On,
  Or,
  Outer,
  Quantile,
  Start,
  Stddev,
  Stdvar,
  Sum,
  Topk,
  Unless,
  Without,
  Zscore,
} from './parser.terms';

const keywordTokens: Record<string, number> = {
  inf: inf,
  nan: nan,
  bool: Bool,
  ignoring: Ignoring,
  on: On,
  group_left: GroupLeft,
  group_right: GroupRight,
  offset: Offset,
  __outer: Outer,
};

export const specializeIdentifier = (value: string) => {
  return keywordTokens[value.toLowerCase()] || -1;
};

const contextualKeywordTokens: Record<string, number> = {
  avg: Avg,
  atan2: Atan2,
  bottomk: Bottomk,
  cardinality_estimate: CardinalityEstimate,
  count: Count,
  count_values: CountValues,
  group: Group,
  max: Max,
  min: Min,
  quantile: Quantile,
  stddev: Stddev,
  stdvar: Stdvar,
  sum: Sum,
  topk: Topk,
  zscore: Zscore,
  by: By,
  without: Without,
  and: And,
  or: Or,
  unless: Unless,
  start: Start,
  end: End,
  fill: Fill,
  fill_left: FillLeft,
  fill_right: FillRight,
};

export const extendIdentifier = (value: string) => {
  return contextualKeywordTokens[value.toLowerCase()] || -1;
};
